import type { FC } from "react";
import type { CustomRef } from "@/utils/types";
import type { ValueOf } from "@/utils/valueOf";
import type { ButtonProps } from "../button/types";

export const ProductContainerSpacing = {
  WIDE: "wide",
  NARROW: "narrow",
  WIDER: "wider",
} as const;
export type ProductContainerSpacing = ValueOf<typeof ProductContainerSpacing>;

// Props type for all container components
export type ProductContainerProps<T extends HTMLElement> = {
  children: React.ReactNode;
  className?: string;
  showSection?: boolean;
} & CustomRef<T>;

export type SectionProductContainerProps = {
  spacing?: ProductContainerSpacing;
  divider?: boolean;
  showSection?: boolean;
  label?: string | null;
} & ProductContainerProps<HTMLDivElement>;

export type SectionProps = {
  title?: string | null;
  component: React.ReactNode;
  divider?: boolean;
};

export type TopQuestionsContainerProps = {
  topSection: SectionProps;
  bottomSection: SectionProps;
};

export interface ProductContainerComponent
  extends FC<ProductContainerProps<HTMLElement>> {
  Section: FC<SectionProductContainerProps>;
  Fieldset: FC<ProductContainerProps<HTMLFieldSetElement>>;
  Entry: FC<ProductContainerProps<HTMLDivElement>>;
  CallToAction: FC<ButtonProps>;
  Loader: FC;
  Form: FC<React.FormHTMLAttributes<HTMLFormElement>>;
  TopQuestions: FC<TopQuestionsContainerProps>;
}
